import {
  AddOutlined,
  RemoveOutlined,
  ShoppingCart,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useHistory } from "react-router-dom";
import "./Cart.css";

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} productId - Unique ID for the product
 */

/**
 * Returns the complete data on all products in cartData by searching in productsData
 *
 * @param { Array.<{ productId: String, qty: Number }> } cartData
 *    Array of objects with productId and quantity of products in cart
 * 
 * @param { Array.<Product> } productsData
 *    Array of objects with complete data on all available products
 *
 * @returns { Array.<CartItem> }
 *    Array of objects with complete data on products in cart
 *
 */



export const generateCartItemsFrom = (cartData, productsData) => {
  if (!cartData) return;
  let cartProductsArray = [];
for (let cartItem=0; cartItem<cartData.length; cartItem++){
  for (let product = 0; product<productsData.length; product++){
    if (cartData[cartItem].productId === productsData[product]._id){
      cartProductsArray.push({...cartData[cartItem], ...productsData[product]});
      break;
    }
  }
}


return cartProductsArray; 
};

/**
 * Get the total value of all products added to the cart
 *
 * @param { Array.<CartItem> } items
 *    Array of objects with complete data on products added to the cart
 *
 * @returns { Number }
 *    Value of all items in the cart
 *
 */
export const getTotalCartValue = (items = []) => {
  // console.log(items)
  // let totalValue = 0;
  // for (let i = 0; i<items.length; i++){
  //   totalValue += items[i].cost;
  // }
  // return totalValue;
  
  return (items.reduce((totalValue, item)=>{return totalValue + (item.cost * item.qty)}, 0))
  
};



// TODO: CRIO_TASK_MODULE_CHECKOUT - Implement function to return total cart quantity
/**
 * Return the sum of quantities of all products added to the cart
 *
 * @param { Array.<CartItem> } items
 *    Array of objects with complete data on products in cart
 *
 * @returns { Number }
 *    Total quantity of products added to the cart
 *
 */
export const getTotalItems = (items=[]) => {
   
  return  (items.reduce((totalQty, item)=>{return totalQty + item.qty},0))
   
  
};

// TODO: CRIO_TASK_MODULE_CHECKOUT - Add static quantity view for Checkout page cart
/**
 * Component to display the current quantity for a product and + and - buttons to update product quantity on cart
 * 
 * @param {Number} value
 *    Current quantity of product in cart
 * 
 * @param {Function} handleAdd
 *    Handler function which adds 1 more of a product to cart
 * 
 * @param {Function} handleDelete
 *    Handler function which reduces the quantity of a product in cart by 1
 * 
 * 
 */
// const handleAdd = (token, items, products, itemId, presentQty)=>{
  
//   let newQty = presentQty + 1;
//   handleQuantity(
//     token,
//     items,
//     products,
//     itemId,
//     newQty,
//     { preventDuplicate: false }
//   )
  
// }

// const handleDelete = (presentQty)=>{
//   let newQty = presentQty - 1;
// }

/*
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const ItemQuantity = ({
  value,
  handleAdd,
  handleDelete,
}) => {
  return (
    <Stack direction="row" alignItems="center">
      <IconButton size="small" color="primary" onClick={handleDelete}>
        <RemoveOutlined />
      </IconButton>
      <Box padding="0.5rem" data-testid="item-qty">
        {value}
      </Box>
      <IconButton size="small" color="primary" onClick={handleAdd}>
        <AddOutlined />
      </IconButton>
    </Stack>
  );
};

/**
 * Component to display the Cart view
 * 
 * @param { Array.<Product> } products
 *    Array of objects with complete data of all available products
 * 
 * @param { Array.<Product> } items
 *    Array of objects with complete data on products in cart
 * 
 * @param {Function} handleDelete
 *    Current quantity of product in cart
 * 
 * @param {Boolean} isReadOnly
 *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
 * 
 */
const Cart = ({
  isReadOnly,
  products,
  items = [],
  handleQuantity,
}) => {
  const history = useHistory();
  let token = localStorage.getItem("token");
  if (!items.length) {
    // console.log(items)
    return (
      <Box className="cart empty">
        <ShoppingCartOutlined className="empty-cart-icon" />
        <Box color="#aaa" textAlign="center">
          Cart is empty. Add more items to the cart to checkout.
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Box container>
      <Box item className="cart">
        {/* TODO: CRIO_TASK_MODULE_CART - Display view for each cart item with non-zero quantity */}
        
        {
        
        items.map((item)=>(
          <Box key={item.productId}>
             {item.qty > 0 ? (<Box display="flex" alignItems="flex-start" padding="1rem">
                  <Box className="image-container">
                  <img
                      // Add product image
                      src={item.image}
                      // Add product name as alt eext
                      alt={item.name}
                      width="100%"
                      height="100%"
                  />
                  </Box>
                  <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                  height="6rem"
                  paddingX="1rem"
                  >
                  <div>{item.name}</div>
                  <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                  >
                    { !isReadOnly ? 
                  (<ItemQuantity
                  // Add required props by checking implementation
                  value = {item.qty}
                  handleAdd = {async ()=> await handleQuantity(token, items, products, item._id, parseInt(item.qty)+1, { preventDuplicate: false } )}
                  handleDelete = {async ()=> await handleQuantity(token, items, products, item._id, item.qty-1, { preventDuplicate: false })}
                  />):(<Box>Qty: {item.qty}</Box>)}
                  <Box padding="0.5rem" fontWeight="700">
                      ${item.cost}
                  </Box>
                  </Box>
                  </Box>
                </Box>) : null}
          </Box>)
        
        )

        }

        <Box
          padding="1rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center">
            Order total
          </Box>
          <Box
            color="#3C3C3C"
            fontWeight="700"
            fontSize="1.5rem"
            alignSelf="center"
            data-testid="cart-total"
          >
            ${getTotalCartValue(items)}
          </Box>
        </Box>
        { !isReadOnly &&
        <Box display="flex" justifyContent="flex-end" className="cart-footer">
          <Button
            color="primary"
            variant="contained"
            startIcon={<ShoppingCart />}
            className="checkout-btn"
            onClick={()=>(history.push("/checkout"))}
          >
            Checkout
          </Button>
        </Box>}
            
      </Box>
      {isReadOnly &&
      <Box item>
      
            <Stack alignItems="center" className="orderDetails">
            <Box width="100%">
              <h3>Order Details</h3>
            </Box>
            <Box display="flex" flexDirection="row"
            justifyContent="space-between" width="100%">
              <p>Products</p>
              <p>
              {getTotalItems(items)}
              </p>
            </Box>
            <Box display="flex" flexDirection="row"
            justifyContent="space-between"  width="100%">
             <p>Subtotal</p>
              <p>${getTotalCartValue(items)}</p>
            </Box>
            <Box display="flex" flexDirection="row"
            justifyContent="space-between" width="100%">
              <p>Shipping Charges</p>
              <p>$0</p>
            </Box>
            <Box display="flex" flexDirection="row"
            justifyContent="space-between" width="100%">
              <h4>Total</h4>
              <h4>${getTotalCartValue(items)}</h4>
            </Box>
          </Stack>
        
      </Box>
      }
    </Box>
    </>
  );
};

export default Cart;
